import { render, staticRenderFns } from "./AmountPageIn.vue?vue&type=template&id=512c62be&scoped=true"
import script from "./AmountPageIn.vue?vue&type=script&lang=js"
export * from "./AmountPageIn.vue?vue&type=script&lang=js"
import style0 from "./AmountPageIn.vue?vue&type=style&index=0&id=512c62be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c62be",
  null
  
)

export default component.exports